import React, { useState } from "react";
import { MdCheckCircleOutline, MdOutlineCancel } from "react-icons/md";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Collapse,
  Modal,
  Tabs,
  Tab,
  Form,
} from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import {
  getActivityPosts,
  purchaseFromPcari,
  getPreviewPost,
  getEditPost,
} from "../../../Store/actions/index";
import Comments from "./Comments/Comments2";
import CommentsModerator from "./Comments/CommentsModerator";
import { useHistory, useLocation } from "react-router";

const AcitvityPosts = ({ posts, postState, vType }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [unlockItem, setUnlockItem] = useState({
    show: false,
    item: null,
    mode: "featured_post",
    validity: "",
    discounted_price: "",
    error: null,
  });
  const [open, setOpen] = useState(null);
  const [showCommentModal, setShowCommentModal] = useState(null);
  const [showModeratorCommentModal, setShowModeratorCommentModal] =
    useState(null);

  const secondaryTile = {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#354052",
  };

  const vehicleTypeDisplayFormater = (type) => {
    if (type === "car" || type === "cars") return "Cars";
    else if (type === "motor" || type === "motors") return "Motorcycle";
    else if (type === "commercial" || type === "commercials")
      return "Commercials";
    else if (type.includes("service")) return "Services";
    else if (type.includes("accessor")) return "Accessories";
    else if (type.includes("rental")) return "Rentals";
    else if (type.includes("apparel")) return "Apparels";
    else {
      return "Post";
    }
  };

  if (posts) {
    return (
      <div style={{ minHeight: "70vh" }}>
        <Row data-aos="fade-down" data-aos-duration="400" data-aos-delay="100">
          {posts && posts.data.length > 0 ? (
            posts.data.map((post) => {
              let img = null;
              if (post.media.length) {
                img = post.media.filter((med) => med.name === "1");
                try {
                  img = img[0].url;
                } catch (error) {
                  img = post.media[0].url;
                }
              }
              return (
                <Col key={post.id} xs={12} className="my-2">
                  <Card className="border-0 shadwo-sm rounded-3">
                    <Card.Body className="border-bottom border-light">
                      <Row className="mx-2">
                        <Col
                          xs={3}
                          className="post-img-container rounded-3 d-none d-lg-block"
                        >
                          <img src={img} className="post-img" alt="first" />
                        </Col>
                        <Col sm={6} className="ps-auto ps-lg-4">
                          <p className="fw-bolder my-0 text-primary">
                            <span style={{ color: "#515352" }}>Post:</span> #
                            {post.id}
                          </p>
                          <p className="fw-bolder my-0 text-primary">
                            {post.title}
                          </p>
                          <p
                            style={{ color: "#515352", fontSize: ".8rem" }}
                            className="fw-bolder my-1"
                          >
                            Last Updated: {post.created_at.slice(0, 10)}
                            <span className="text-primary">
                              {post.created_at.slice(10)}
                            </span>
                          </p>
                          <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                            {vehicleTypeDisplayFormater(post.vehicle_type)}
                          </button>
                          <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                            Featured
                            {post.is_featured === 1 ? (
                              <MdCheckCircleOutline className="text-success ms-2" />
                            ) : (
                              <MdOutlineCancel className="text-danger ms-2" />
                            )}
                          </button>
                          <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                            FastDeal
                            {post.is_fast_deal === 1 ? (
                              <MdCheckCircleOutline className="text-success ms-2" />
                            ) : (
                              <MdOutlineCancel className="text-danger ms-2" />
                            )}
                          </button>
                        </Col>
                        <Col sm={6} lg={3}>
                          {postState === "published" && (
                            <div className="d-flex flex-column justify-content-between align-items-sm-center align-items-sm-end h-100">
                              <Button
                                variant="primary"
                                className="text-white shadow-none mb-4 mb-sm-0"
                                onClick={() => {
                                  setShowCommentModal(post);
                                }}
                              >
                                <small>View Comments</small>
                              </Button>

                              <Button
                                variant="primary"
                                className="text-white shadow-none"
                                size="lg"
                                onClick={() => {
                                  setUnlockItem((prev) => {
                                    return { ...prev, item: post, show: true };
                                  });
                                }}
                              >
                                Unlock features
                              </Button>
                            </div>
                          )}
                          {postState === "reviewed" && (
                            <div className="d-flex flex-column justify-content-between align-items-sm-center align-items-sm-end h-100">
                              <Button
                                variant="primary"
                                className="text-white shadow-none w-100 mb-4 mb-sm-0"
                                onClick={() => {
                                  setShowModeratorCommentModal(post);
                                }}
                              >
                                <small>View Comments</small>
                              </Button>

                              <Button
                                variant="primary"
                                className="text-white shadow-none w-100"
                                onClick={() => {
                                  dispatch(getEditPost(post.id));
                                  localStorage.setItem("draftId", post.id);
                                  history.push("/Edit", {
                                    postMode: "reviewed",
                                  });
                                }}
                              >
                                Edit
                              </Button>
                            </div>
                          )}
                          {postState === "onHold" && (
                            <Button
                              variant="primary"
                              className="text-white shadow-none w-100"
                              onClick={() => {
                                localStorage.removeItem("draftId");
                                dispatch(getPreviewPost(post.id));
                                history.push("/Preview", {
                                  prevPath: location.pathname,
                                });
                              }}
                            >
                              View
                            </Button>
                          )}
                          {postState === "draft" && (
                            <Button
                              variant="primary"
                              className="text-white shadow-none w-100"
                              onClick={() => {
                                dispatch(getEditPost(post.id));
                                localStorage.setItem("draftId", post.id);
                                history.push("/Edit", { postMode: "draft" });
                              }}
                            >
                              Edit
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Card.Body>
                    <Card.Footer className="bg-white">
                      {/* EXPAND  START  */}
                      <Row className="mx-2">
                        <Col>
                          <p
                            style={{ color: "#3100FC" }}
                            className="m-0 cursor-pointer"
                            onClick={() => {
                              if (open === post.id) setOpen(null);
                              else setOpen(post.id);
                            }}
                          >
                            {open === post.id ? "COLLAPSE" : "EXPAND"}
                          </p>
                        </Col>
                      </Row>
                      <Row className="mx-2">
                        <Col>
                          <Collapse in={open === post.id}>
                            <Row>
                              <Col>
                                <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                                  Featured
                                  {post.is_featured === 1 ? (
                                    <MdCheckCircleOutline className="text-success mx-2" />
                                  ) : (
                                    <MdOutlineCancel className="text-danger mx-2" />
                                  )}
                                </button>
                              </Col>
                              <Col>
                                <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                                  Fast Deal
                                  {post.is_fast_deal === 1 ? (
                                    <MdCheckCircleOutline className="text-success mx-2" />
                                  ) : (
                                    <MdOutlineCancel className="text-danger mx-2" />
                                  )}
                                </button>
                              </Col>
                              <Col>
                                <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                                  Bumped
                                  {post.is_bumped === 1 ? (
                                    <MdCheckCircleOutline className="text-success mx-2" />
                                  ) : (
                                    <MdOutlineCancel className="text-danger mx-2" />
                                  )}
                                </button>
                              </Col>
                              <Col>
                                <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                                  Hot Deal
                                  {post.is_hot_deal === 1 ? (
                                    <MdCheckCircleOutline className="text-success mx-2" />
                                  ) : (
                                    <MdOutlineCancel className="text-danger mx-2" />
                                  )}
                                </button>
                              </Col>
                            </Row>
                          </Collapse>
                        </Col>
                      </Row>
                      {/* EXPAND  END  */}
                    </Card.Footer>
                  </Card>
                </Col>
              );
            })
          ) : (
            <Card className="border-0 shadow-sm" style={{ minHeight: "30vh" }}>
              <Card.Body className="d-flex justify-content-center align-items-center">
                <p className="text-tertiary">No adds found</p>
              </Card.Body>
            </Card>
          )}

          {/*Featurs Modal Start */}
          <Modal
            show={unlockItem.show}
            onHide={() =>
              setUnlockItem((prev) => {
                return {
                  ...prev,
                  show: false,
                  item: null,
                  validity: "",
                  discounted_price: "",
                  mode: "featured_post",
                  error: null,
                };
              })
            }
          >
            <Modal.Header>
              <Modal.Title>
                <h1>Unlock Ad Features</h1>
              </Modal.Title>
            </Modal.Header>
            {unlockItem.item && (
              <Modal.Body>
                <Tabs
                  defaultActiveKey="feature"
                  className="mb-3"
                  onSelect={(select) =>
                    setUnlockItem((prev) => {
                      return {
                        ...prev,
                        mode: select,
                        error: null,
                        validity: "",
                      };
                    })
                  }
                >
                  <Tab eventKey="feature" title="Featured">
                    <h5 style={secondaryTile}>Unlock Featured</h5>
                    <p>
                      Unlock Featured to gain more user interaction with your
                      add
                    </p>
                  </Tab>
                  <Tab eventKey="fast_deal" title="Fast Deal">
                    <h5 style={secondaryTile}>Unlock Fast Deal</h5>
                    <p>
                      Unlock Fast Deal to gain more user interaction with your
                      add
                    </p>
                  </Tab>
                  <Tab eventKey="bump" title="Bumped">
                    <h5 style={secondaryTile}>Unlock Fast Deal</h5>
                    <p>
                      Unlock Bumped to gain more user interaction with your add
                    </p>
                  </Tab>
                </Tabs>
                {unlockItem.mode === "fast_deal" && (
                  <Form.Group className="mb-5">
                    <Form.Label>
                      Discounted Price<sup className="text-danger">*</sup>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      isInvalid={unlockItem.error}
                      onChange={(e) =>
                        setUnlockItem((prev) => {
                          return {
                            ...prev,
                            discounted_price: e.target.value,
                            error: null,
                          };
                        })
                      }
                    />
                  </Form.Group>
                )}
                <Form.Group className="mb-5">
                  <Form.Label>
                    Pricings<sup className="text-danger">*</sup>
                  </Form.Label>
                  <Form.Control
                    isInvalid={unlockItem.error}
                    as="select"
                    value={unlockItem.validity}
                    onChange={(e) =>
                      setUnlockItem((prev) => {
                        return {
                          ...prev,
                          validity: e.target.value,
                          error: null,
                        };
                      })
                    }
                  >
                    <option hidden value>
                      Select
                    </option>
                    <option value="14">14 Days for RM5</option>
                    <option value="30">30 Days for RM10</option>
                    <option value="90">90 Days for RM15</option>
                  </Form.Control>
                </Form.Group>
                <Row>
                  <Col>
                    <Button
                      variant="outline-primary"
                      onClick={() => {
                        if (
                          unlockItem.mode === "fast_deal" &&
                          unlockItem.discounted_price !== "" &&
                          unlockItem.validity !== ""
                        ) {
                          dispatch(
                            purchaseFromPcari(
                              "all",
                              unlockItem.mode,
                              unlockItem.item.id,
                              unlockItem.validity,
                              unlockItem.discounted_price,
                              "published"
                            )
                          );
                        } else
                          setUnlockItem((prev) => {
                            return {
                              ...prev,
                              error: "please fill required feilds.",
                            };
                          });

                        if (
                          ["bump", "feature"].includes(unlockItem.mode) &&
                          unlockItem.validity !== ""
                        ) {
                          dispatch(
                            purchaseFromPcari(
                              "all",
                              unlockItem.mode,
                              unlockItem.item.id,
                              unlockItem.validity,
                              undefined,
                              "published"
                            )
                          );
                        } else
                          setUnlockItem((prev) => {
                            return {
                              ...prev,
                              error: "please fill required feilds.",
                            };
                          });

                        setUnlockItem((prev) => {
                          return {
                            ...prev,
                            show: false,
                            item: null,
                            validity: "",
                            discounted_price: "",
                            mode: "featured_post",
                            error: null,
                          };
                        });
                      }}
                    >
                      Confirm
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            )}
          </Modal>
          {/*Featurs Modal end */}

          {/*Comments Modal start */}
          <Modal
            show={showCommentModal}
            onHide={() => setShowCommentModal(null)}
          >
            <Modal.Header>
              <Modal.Title>
                <h1>Comments</h1>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Comments
                comments={showCommentModal}
                postState={postState}
                closeModal={setShowCommentModal}
                vType={vType}
              />
            </Modal.Body>
          </Modal>
          {/*Comments Modal end */}
          {/*Moderator Modal start */}
          <Modal
            show={showModeratorCommentModal}
            onHide={() => setShowModeratorCommentModal(null)}
          >
            <Modal.Header>
              <Modal.Title>
                <h1>Comments</h1>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <CommentsModerator
                comments={showModeratorCommentModal}
                postState={postState}
                closeModal={setShowModeratorCommentModal}
                vType={vType}
              />
            </Modal.Body>
          </Modal>
          {/*Moderator Modal end */}
        </Row>
      </div>
    );
  } else return null;
};

export default AcitvityPosts;
